const registerServiceWorker = async () => {
    if ('serviceWorker' in navigator) {
        await navigator.serviceWorker.register('/service.js');
        return navigator.serviceWorker.ready;
    } else {
        throw new Error('No Service Worker support!')
    }
}

const requestNotificationPermission = async () => {
    if ('PushManager' in window) {
        const permission = await window.Notification.requestPermission();
        if (permission !== 'granted') {
            throw new Error('Permission not granted for Notification');
        }
    } else {
        throw new Error('No Push API Support!')
    }
}

registerServiceWorker()
    .then((service_worker_registration) => {
        console.log('Service worker installed.', {service_worker_registration});

        if (window.ref_app_client_id ?? null) {
            requestNotificationPermission()
                .then(() => {
                    console.log('Notification permission aquired');


                    // This way it should only try to register if all settings are saved
                    service_worker_registration.active.postMessage({
                        command: 'pushManagerSubscribe',
                        attr: [window.ref_app_push_server_url, window.ref_app_push_subscription],
                    });
                })
                .catch(err => console.error('Error while enabling notifications', err));
        } else {
            service_worker_registration.active.postMessage({
                command: 'pushManagerUnsubscribe',
            });
        }
    })
    .catch(err => console.error('Error installing service worker', err));
